import { combineEpics, Epic } from 'redux-observable'
import { filter, mergeMap } from 'rxjs/operators'
import { isActionOf } from 'typesafe-actions'

import * as actions from './actions'
import { funnelOrderThemeCitiesEpic } from './funnelOrder/themeCities/epic'

const initEpic: Epic = action$ =>
  action$.pipe(
    filter(isActionOf(actions.init)),
    mergeMap(() => []),
  )

export const rootEpic = combineEpics(initEpic, funnelOrderThemeCitiesEpic)
